import { render, staticRenderFns } from "./CatalogCartBtn.vue?vue&type=template&id=b9e0151e"
import script from "./CatalogCartBtn.vue?vue&type=script&lang=ts"
export * from "./CatalogCartBtn.vue?vue&type=script&lang=ts"
import style0 from "./CatalogCartBtn.vue?vue&type=style&index=0&id=b9e0151e&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports